import createLucideIcon from '../createLucideIcon';

const ChevronRight = createLucideIcon('ChevronRight', [
  ['polyline', { points: '9 18 15 12 9 6', key: '1rtp27' }],
]);

export default ChevronRight;
